import * as fromBase from './admin.selectors';
import * as fromClosures from './closures-admin.selectors';
import * as fromFittings from './fittings-admin.selectors';

export const ADMIN = {
  ...fromBase,
  ...fromClosures,
  ...fromFittings
};
